/**
 * App.js — HustleRoundup Sprint 2 route table.
 *
 * The bootstrap tarball dropped a RootRouter.jsx aimed at the droplet's
 * full HustleSuite fleet (imports HomePage, SalesPage, PlazaSalesPage,
 * etc.) — none of those pages exist in this pod. Sprint 2 is
 * HustleRoundup-only, so we route directly to the module pages here and
 * treat `/` as the HustleRoundup landing.
 */
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import HustleRoundupLandingPage from "@/pages/HustleRoundupLandingPage";
import HustleRoundupLoginPage    from "@/pages/HustleRoundupLoginPage";
import HustleRoundupLobbyPage    from "@/pages/HustleRoundupLobbyPage";
import HustleRoundupPreJoinPage  from "@/pages/HustleRoundupPreJoinPage";
import HustleRoundupRoomPage     from "@/pages/HustleRoundupRoomPage";
import HustleRoundupSchedulePage from "@/pages/HustleRoundupSchedulePage";
import HustleRoundupJoinPage     from "@/pages/HustleRoundupJoinPage";
import HustleRoundupHistoryPage  from "@/pages/HustleRoundupHistoryPage";
import HustleRoundupRecordingPage from "@/pages/HustleRoundupRecordingPage";
import AdminHustleRoundupPage    from "@/pages/AdminHustleRoundupPage";

export default function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" />
        <Routes>
          <Route path="/"                           element={<HustleRoundupLandingPage />} />
          <Route path="/login"                      element={<HustleRoundupLoginPage />} />
          <Route path="/meet"                       element={<HustleRoundupLobbyPage />} />
          <Route path="/meet/prejoin/:roomName"     element={<HustleRoundupPreJoinPage />} />
          <Route path="/meet/:roomName"             element={<HustleRoundupRoomPage />} />
          <Route path="/schedule"                   element={<HustleRoundupSchedulePage />} />
          <Route path="/join/:code"                 element={<HustleRoundupJoinPage />} />
          <Route path="/history"                    element={<HustleRoundupHistoryPage />} />
          <Route path="/recording/:id"              element={<HustleRoundupRecordingPage />} />
          <Route path="/admin/hustleroundup"        element={<AdminHustleRoundupPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
